import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	height: calc(100vh - 150px);
	min-height: 800px;
	background-color: #24376c;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	@media screen and (max-width: 1200px) {
		right: 50%;
		transform: translateX(50%);
	}
	@media screen and (max-width: 800px) {
		min-height: 900px;
	}
	@media screen and (max-width: 600px) {
		min-height: 1000px;
	}
	@media screen and (max-width: 450px) {
		min-height: 1100px;
	}
`;

export const ContentContainer = styled.div`
	display: flex;
	margin-bottom: 150px;
	flex-flow: column nowrap;
	justify-content: center;
	z-index: 9;
	@media screen and (max-width: 1200px) {
		margin-right: unset;
	}
`;

export const HeadingsContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	width: 95%;
	margin: auto;
	text-align: center;
	@media screen and (max-width: 1200px) {
		align-items: center;
	}
`;

export const HeadingFont = styled.p`
	margin: 0;
	line-height: 1.2;
	font-size: 28px;
	color: #fff;
	font-family: Montserrant-Black;
	span {
		color: #eff3a9;
	}
`;

export const GenericFont = styled.p`
	margin: 0;
	line-height: 1.2;
	font-size: 16px;
	color: #cccccc;
	@media screen and (max-width: 600px) {
		text-align: center;
	}
`;

export const ContributionInfoContainer = styled.div`
	display: flex;
	flex-flow: row nowrap;
	width: 860px;
	height: 150px;
	border: 2px solid rgb(0, 131, 200);
	margin: 40px 0;
	border-radius: 20px;
	@media screen and (max-width: 1200px) {
		margin: 40px 10px;
		width: auto;
		height: auto;
	}
	@media screen and (max-width: 600px) {
		flex-flow: column nowrap;
	}
	@media screen and (max-width: 400px) {
		margin: 40px 0;
	}
`;

export const ContributionDecor = styled.div`
	border-radius: 15px 0 0 15px;
	background-color: rgb(0, 131, 200);
	height: 100%;
	min-width: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: #fff;
		width: 70px;
		height: 70px;
	}
	@media screen and (max-width: 1200px) {
		height: auto;
	}
	@media screen and (max-width: 600px) {
		height: 90px;
		border-radius: 15px 15px 0 0;
	}
`;

export const InfoContentContainer = styled.div`
	padding: 30px 20px;
	border-radius: 0 22px 22px 0;
	width: 100%;
	background-color: #24376c;
	@media screen and (max-width: 600px) {
		border-radius: 0 0 22px 22px;
	}
`;

export const ContributionContainer = styled.div`
	display: flex;
	flex-flow: row nowrap;
	width: 100%;
	& > p:nth-child(1) {
		margin-top: 16px;
		margin-bottom: 12px;
		line-height: 1.1;
		color: #fff;
		flex: 4;
		font-size: 24px;
		font-weight: 600;
	}
	& > p:nth-child(2) {
		margin-top: 16px;
		margin-bottom: 12px;
		line-height: 1.1;
		color: #eff3a9;
		flex: 1;
		text-align: right;
		font-size: 28px;
		font-weight: 900;
		white-space: nowrap;
	}
	@media screen and (max-width: 400px) {
		flex-flow: column nowrap;
		align-items: center;
		text-align: center;
		& > p:nth-child(2) {
			margin-top: 0;
		}
	}
`;

export const PaywallContainer = styled.div`
	width: 95%;
	margin: auto;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
		align-items: center;
	}
`;

export const PaywallButton = styled.button`
	all: unset;
	cursor: pointer;
	width: 300px;
	border: 2px solid #eff3a9;
	border-radius: 100px;
	padding: 14px 10px;
	color: #fff;
	text-align: center;
	font-weight: 600;
	font-size: 16px;
	@media screen and (max-width: 800px) {
		margin: 0;
		margin-top: 30px;
	}
`;

export const FooterWrapper = styled.div`
	height: 150px;
	width: 100%;
	background-image: linear-gradient(
		135deg,
		#24376c 25%,
		#293f7b 25%,
		#293f7b 50%,
		#24376c 50%,
		#24376c 75%,
		#293f7b 75%,
		#293f7b 100%
	);
	background-size: 15px 15px;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 1200px) {
		height: 175px;
	}
	@media screen and (max-width: 800px) {
		height: 200px;
	}
	@media screen and (max-width: 600px) {
		height: 225px;
	}
	@media screen and (max-width: 450px) {
		height: 250px;
	}
`;

export const FooterGenericFont = styled.p`
	margin: 0;
	line-height: 1.4;
	font-size: 14px;
	color: #cccccc;
	text-align: center;
	padding: 0 4px;
	span {
		font-weight: 600;
		color: #fff;
	}
	a {
		text-decoration: none;
	}
`;
